export function addQuerystringParam(url: string, name: string, value: string) {
  const newUrl = new URL(url);
  newUrl.searchParams.set(name, value);
  return newUrl.toString();
}
